<div #chartContainer width="100%"></div>
